// extracted by mini-css-extract-plugin
module.exports = {"jobInfos":"JobInfos_jobInfos__2Y_Uc","jobInfosDivider":"JobInfos_jobInfosDivider__3ze87"};